import { AuthFlow, AuthFlowError } from '@griply/types';
import { useMutation } from '@tanstack/react-query';
import { getAppleToken } from 'shared/services/apple';
import { handleAuthError } from 'shared/services/backend-api/helpers';

export const useLoginUserWithAppleMutation = () =>
  useMutation<void, AuthFlowError>({
    mutationFn: async () => {
      try {
        await getAppleToken();
      } catch (error) {
        throw handleAuthError(error, AuthFlow.AppleSignIn);
      }
    },
  });
